export interface Point {
  x: number;
  y: number;
}

export function pointToString(point: Point): string {
  return `${point.x},${point.y}`;
}

export type Angle = number;
